










































































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import FormCard from '@/components/form/FormCard.vue'
import IconWithText from '@/components/form/IconWithText.vue'
import TextField from '@/components/form/TextField.vue'
import ContactNumberField from '@/components/form/ContactNumberField.vue'
import SelectField from '@/components/form/SelectField.vue'
import VerifyDocumentUpload from '@/components/verificationuploadslots/VerifyDocumentUpload.vue'
import SupportEmail from '@/components/general/SupportEmail.vue'
import verificationStepMixin from '@/mixins/verification-step-mixin'
import validationMixin from '@/mixins/validation-mixin'

@Component({
  components: {
    VerifyDocumentUpload,
    FormCard,
    IconWithText,
    TextField,
    ContactNumberField,
    SelectField,
    SupportEmail,
  },
})
export default class VerificationHPCSA extends mixins(
  validationMixin,
  verificationStepMixin,
) {
  verificationError = 'The person in the image does not match the person in the profile picture'

  displayErrorDialog = false

  isVerifying = false

  manualVerificationOption = false

  get isVerified() {
    return this.userProfile.isHpcsaDocumentVerified
  }

  set isVerified(newVal: boolean) {
    this.userProfile.isHpcsaDocumentVerified = newVal
  }

  updateHPCSAPicture() {
    this.isVerifying = false
    this.isVerified = true
    this.updateStore()
    this.$emit('complete', true)
  }

  toProfile() {
    if (this.isVerified) {
      this.updateStore()
      this.$emit('next')
    } else {
      this.$emit('complete', false)
      this.$emit('next')
    }
  }

  showErrors(errorMessage: string) {
    this.$emit('error', errorMessage)
    this.manualVerificationOption = true
    this.isVerifying = false
  }
}
